import { environment } from '@stockcare-environments/environment';
import { FetchToken } from './fetchToken';

export function JwtOptionsFactory() {
  return {
    tokenGetter: FetchToken.get,
    whitelistedDomains: environment.whitelistedDomains,
    allowedDomains: environment.whitelistedDomains,
  };
}
